module.exports = __webpack_public_path__ + "static/media/image.6a1bdb45.png";